module.exports = __webpack_public_path__ + "img/9791159923241.241e8fe1.jpg";